import { Accordion, AccordionDetails, AccordionSummary, Box, Typography, SxProps } from '@mui/material'
import { useState } from 'react'
import KeyValueGrid from '../../components/KeyValueGrid';
import RenderElement from '../../components/RenderElement';
import { formatDuration } from '../../utils/utils';

const sxSummary: SxProps = {
    padding: 0,
    minHeight: 'unset',
    marginBottom: '-1px',
    border: 0,
    '&.Mui-expanded': {
        minHeight: 'unset',
    },
    '.MuiAccordionSummary-content': {
        display: 'block',
        margin: 0,
        border: 0,
        '&.Mui-expanded': {
            margin: 0
        }
    }
}

const AccordionDetailsSxProps = {
    display: 'block',
    padding: 0,
    border: 0,
}


type Props = {
    span: any
    ticks: any[]
    totalDuration: number
    index?: number
    startTime?: string
}
const Span = (props: Props) => {
    const { span, ticks, totalDuration, index, startTime = '' } = props;
    const width = (span.Duration / totalDuration) * 100 + '%';
    const startDate = new Date(startTime);
    const dateObject2 = new Date(span?.Timestamp);

    // Get timestamps in milliseconds
    const timestamp1InMs = startDate.getTime();
    const timestamp2InMs = dateObject2.getTime();

    // Calculate difference in milliseconds
    const differenceInMs = timestamp2InMs - timestamp1InMs;

    // Convert milliseconds to nanoseconds (multiply by 1,000,000)
    const differenceInNanoseconds = differenceInMs * 1000000;

    const start = (differenceInNanoseconds / totalDuration) * 100 + '%';

    const [expanded, setExpanded] = useState(false);
    const handleAccordianChange = () => {
        setExpanded(prev => !prev)
    }

    return (
        <>


            <Accordion square expanded={expanded} elevation={0} onChange={handleAccordianChange} sx={{ margin: '0 !important' }}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" sx={sxSummary}>
                    <Box display="flex" borderBottom={1} borderColor="background.default" sx={{ '&:hover': { bgcolor: 'grey.100' } }}>
                        <Box width={320} bgcolor="grey.200" display="flex">
                            {Array.apply(null, Array(index)).map(() => <Box paddingX={1} display="inline-flex" height="100%" borderLeft={1} borderColor="grey.300" />)}
                            <Box paddingX={1} paddingY={1} borderLeft={3} borderColor="rgb(23, 184, 190)" >
                                <Typography fontWeight={600}>{span?.ServiceName} ({span?.Operation})</Typography>
                                <Typography fontSize={"smaller"}>{span?.SpanName}</Typography>
                            </Box>
                        </Box>
                        <Box flexGrow={1} position="relative">
                            {ticks.map(tick => <Box position="absolute" top={0} height="100%" borderLeft={1} borderColor="grey.400" left={`${tick.portion * 100}%`} />)}
                            <Box position="absolute" width={width} top="50%" height={10} borderRadius={1} bgcolor="rgb(23, 184, 190)" left={start} sx={{ transform: 'translateY(-50%)' }}>
                                <RenderElement show={true}>
                                    <Typography top={"-20px"} left={start} noWrap position="absolute">{formatDuration(span.Duration)}</Typography>
                                </RenderElement>
                            </Box>
                        </Box>
                    </Box>
                </AccordionSummary>
                <AccordionDetails sx={AccordionDetailsSxProps}>
                    <Box paddingLeft="320px">
                        <Box borderLeft={1} borderTop={1} borderColor="divider" px={2} pt={1.5}>
                            <Typography fontSize={14} fontWeight={600} mb={1}>Attributes</Typography>
                            <KeyValueGrid
                                keyValuePair={span || {}}
                                containerColumn={12}
                                keyColumn={3}
                                valueColumn={9}
                                noBorder
                            />
                        </Box>
                    </Box>
                </AccordionDetails>
            </Accordion>
        </>
    )
}

export default Span